export default __webpack_public_path__ + "static/media/arrow.96dd0397.svg";